import { DocumentFilter } from "@/lib/redux/documentFilters/documentFiltersSlice";
import { useAppSelector } from "@/lib/redux/hooks";
import { newsFilterSelectors } from "@/lib/redux/store";
import React, { useState } from "react";
import Selector from "./Selector";
import { Container } from "./styles";

const Filters: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<null | DocumentFilter>();
  const filters = useAppSelector(newsFilterSelectors.selectAll);

  return (
    <Container>
      {filters.map((filter) => (
        <Selector
          key={filter.id}
          filter={filter}
          isOpen={filter.id === activeFilter?.id}
          handleOpen={() => setActiveFilter(filter)}
          handleClose={() => setActiveFilter(null)}
        />
      ))}
    </Container>
  );
};

export default Filters;
